module.exports = __webpack_public_path__ + "img/四川天府新区永兴小学.e2824170.jpg";